import React, { useState } from 'react';
import { Outlet, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  FiGrid, FiUsers, FiFileText, FiPackage, FiBarChart2,
  FiSettings, FiLogOut, FiMenu, FiX, FiScissors, FiClock
} from 'react-icons/fi';

const NavItem = ({ to, icon: Icon, label, onClick }) => {
  const location = useLocation();
  const isActive = to ? location.pathname === to || location.pathname.startsWith(to + '/') : false;
  if (onClick) {
    return (
      <button className="nav-item" onClick={onClick}>
        <Icon size={16} />{label}
      </button>
    );
  }
  return (
    <NavLink to={to} className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`} end={to === '/'}>
      <Icon size={16} />{label}
    </NavLink>
  );
};

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const titles = {
    '/': 'Dashboard',
    '/customers': 'Customers',
    '/customers/add': 'Add Customer',
    '/bills': 'Sale History',
    '/bills/create': 'Create Bill',
    '/inventory': 'Inventory',
    '/reports': 'Reports',
    '/settings': 'Settings',
  };

  const title = Object.entries(titles).reverse().find(([p]) => location.pathname.startsWith(p))?.[1] || 'Dashboard';

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div className="app-layout">
      {/* Overlay for mobile */}
      {sidebarOpen && <div onClick={() => setSidebarOpen(false)} style={{ position:'fixed',inset:0,background:'rgba(0,0,0,0.4)',zIndex:99 }} />}

      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <FiScissors size={20} color="#f59e0b" />
            <div>
              <div className="sidebar-logo">Saad bin shalwah</div>
              <div className="sidebar-sub">Saad bin shalwah Manager</div>
            </div>
          </div>
        </div>

        <nav className="sidebar-nav">
          <NavItem to="/" icon={FiGrid} label="Dashboard" />
          
          <div className="nav-group-label">Customers</div>
          <NavItem to="/customers" icon={FiUsers} label="All Customers" />

          <div className="nav-group-label">Billing</div>
          <NavItem to="/bills" icon={FiFileText} label="Sale History" />

          {user?.role === 'admin' && (
            <>
              <div className="nav-group-label">Management</div>
              <NavItem to="/inventory" icon={FiPackage} label="Inventory" />
              <NavItem to="/reports" icon={FiBarChart2} label="Reports" />
              <NavItem to="/settings" icon={FiSettings} label="Settings" />
            </>
          )}
        </nav>

        <div className="sidebar-footer">
          <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 12, marginBottom: 8, paddingLeft: 8 }}>
            👤 {user?.name} ({user?.role})
          </div>
          <NavItem icon={FiLogOut} label="Logout" onClick={handleLogout} />
        </div>
      </aside>

      <div className="main-content">
        <header className="topbar">
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <button className="btn btn-outline btn-icon" onClick={() => setSidebarOpen(!sidebarOpen)}
              style={{ display: 'none' }} id="menu-btn">
              <FiMenu size={18} />
            </button>
            <button className="btn btn-outline btn-icon sidebar-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
              {sidebarOpen ? <FiX size={18} /> : <FiMenu size={18} />}
            </button>
            <h1 className="topbar-title">{title}</h1>
          </div>
          <div className="topbar-actions">
            <span style={{ fontSize: 12, color: '#64748b' }}>
              {new Date().toLocaleDateString('en-AE', { timeZone: 'Asia/Riyadh', weekday: 'short', day: 'numeric', month: 'short' })}
            </span>
          </div>
        </header>
        <main className="page-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}